import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DEFAULT_LABEL_POSITION, DEFAULT_LABEL_SIZE, FORM_GROUP_DEFAULT_MODE } from './FormGroup.constants';
import { FormGroupRoot } from './FormGroup.styled';
import { FormGroupExplain } from './FormGroupExplain';
import { FormGroupLabel } from './FormGroupLabel';
// High Order Component.
// -----------------------------------------------------------------------------
export function withFormGroup(WrappedComponent) {
    return function withFormGroup(props) {
        const position = props.formGroup?.label?.position || DEFAULT_LABEL_POSITION;
        const explainRole = props.formGroup?.explain?.role
            ? props.formGroup?.explain.role
            : props.role
                ? props.role
                : 'none';
        return (_jsxs(FormGroupRoot, { mode: props.mode ?? FORM_GROUP_DEFAULT_MODE, position: position, hasLabel: !!props.formGroup?.label?.content, children: [props.formGroup?.label && (_jsx("div", { className: "ui-fg-label", children: _jsx(FormGroupLabel, { details: props.formGroup.label.details, mode: props.mode ?? FORM_GROUP_DEFAULT_MODE, name: props.name, position: position, size: props.size ?? DEFAULT_LABEL_SIZE, children: props.formGroup.label.content }) })), _jsx("div", { className: "ui-fg-field", children: _jsx(WrappedComponent, { ...props }) }), props.formGroup?.explain && (_jsx("div", { className: "ui-fg-explain", children: _jsx(FormGroupExplain, { role: explainRole, children: props.formGroup.explain.content }) }))] }));
    };
}
//# sourceMappingURL=FormGroup.js.map